import React, { useEffect, useState } from 'react';
import { fetchLoans } from '../api';

const LoansTable = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchLoans()
      .then(res => {
        setData(res.data);
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="container-fluid mt-4 px-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="text-black fw-bold">Loan Inquiries</h4>
        <span className="badge bg-secondary">{data.length} Records Found</span>
      </div>

      {isLoading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status"></div>
          <p className="mt-2 text-muted">Loading Data...</p>
        </div>
      ) : (
        <div className="table-responsive shadow-sm rounded">
          <table className="table table-hover table-striped table-bordered align-middle mb-0">
            <thead className="table-dark text-center align-middle">
              <tr>
                <th>ID</th>
                <th>Applicant Name</th>
                <th>Guardian Name</th>
                <th>Loan Type</th>
                <th>Date of Birth</th>
                <th>Gender</th>
                <th>Mobile Number</th>
                <th>State</th>
                <th>District</th> {/* UPDATED LABEL */}
                <th>Annual Income</th>
                <th>Email Address</th>
                <th>Aadhar Number</th>
                <th>Submission Date</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={item.id || index}>
                    <td className="text-center fw-bold">{index + 1}</td>
                    
                    <td className="fw-semibold">{item.applicantName}</td>
                    <td>{item.guardianName || '-'}</td>
                    
                    <td>
                      <span className="badge bg-info text-dark">{item.loanType}</span>
                    </td>
                    
                    <td className="text-center">
                      {item.dateOfBirth ? new Date(item.dateOfBirth).toLocaleDateString() : '-'}
                    </td>
                    
                    <td>{item.gender}</td>
                    
                    <td className="text-center">
                      <a href={`tel:${item.mobileNumber}`} className="text-decoration-none fw-bold">
                        {item.mobileNumber}
                      </a>
                    </td>
                    
                    {/* --- FIX: Display State and District --- */}
                    <td>{item.state || '-'}</td>
                    <td>{item.district || '-'}</td> 
                    {/* -------------------------------------- */}

                    <td>{item.annualFamilyIncome}</td>
                    
                    <td>
                      {item.emailAddress ? (
                        <a href={`mailto:${item.emailAddress}`} className="text-decoration-none">
                          {item.emailAddress}
                        </a>
                      ) : '-'}
                    </td>
                    
                    <td className="text-center">
                      {item.aadharNumber ? (
                        <span className="text-dark font-monospace">{item.aadharNumber}</span>
                      ) : (
                        <span className="text-muted small">Not Provided</span>
                      )}
                    </td>
                    
                    <td className="text-center small text-muted">
                      {item.submissionDate ? new Date(item.submissionDate).toLocaleString() : '-'}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="13" className="text-center py-4 text-muted">
                    No loan inquiries found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default LoansTable;